import React from "react"
import PropTypes from "prop-types"
import styles from "../../UploadFile/index.module.css"

/**
 * ErrorDisplay Component
 * Displays error messages for file upload
 * Follows Single Responsibility Principle
 */
const ErrorDisplay = ({ error }) => {
  if (!error) return null

  return (
    <div className={styles.errorContainer}>
      <span className={styles.errorText}>{error}</span>
    </div>
  )
}

ErrorDisplay.propTypes = {
  error: PropTypes.string
}

export default ErrorDisplay
